module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iterators.js
// module id = 84
// module chunks = 1